var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 2,
    viewBox: "0 0 11 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#001246",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1374.037 210c.271 0 .502.095.692.286.176.19.271.435.271.707 0 .286-.095.53-.271.721-.19.19-.42.286-.692.286-.298 0-.529-.109-.705-.3-.19-.19-.272-.435-.272-.707 0-.272.082-.517.272-.707.19-.19.42-.286.705-.286zm-4.53 0c.271 0 .502.095.692.286.176.19.27.435.27.707 0 .286-.094.53-.27.721-.19.19-.421.286-.692.286-.299 0-.53-.109-.706-.3-.19-.19-.27-.435-.27-.707 0-.272.08-.517.27-.707.19-.19.421-.286.706-.286zm-4.53 0c.27 0 .501.095.691.286.177.19.272.435.272.707 0 .286-.095.53-.272.721-.19.19-.42.286-.691.286-.299 0-.53-.109-.706-.3-.19-.19-.271-.435-.271-.707 0-.272.081-.517.271-.707.19-.19.42-.286.706-.286z",
    transform: "translate(-1364 -210)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOption);
export default __webpack_public_path__ + "static/media/option.73824a06fe0db37a97ff916965632c6e.svg";
export { ForwardRef as ReactComponent };